module.exports = __webpack_public_path__ + "img/logo-redondo.319212dd.svg";